import Helmet from "react-helmet";
import React, { useEffect } from "react";
import styles from "./login.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";

const LogIn = () => {

    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
    const history = useHistory();

    useEffect(() => {
        if (!isLoading && isAuthenticated) {
            history.replace(
                sessionStorage.getItem("returnTo") || "/admin"
            );
        }
    }, [isAuthenticated, isLoading, history]);

    const login = (connection) => {
        loginWithRedirect({
            login_type: connection,
            backurl: process.env.REACT_APP_BASE_URL + "/login",
            isWeb: true,
            appState: {
                returnTo: sessionStorage.getItem("returnTo") || "/dashboard",
            },
        });
    };

    if (isLoading) {
        return null; // or show a loader
    }

    return (<>
        <Helmet title="Login" />

        <div className={`${styles.screen}`}>

            {/* LEFT: method selection */}
            <div className={`${styles.left}`}>

                <div className={`${styles.brand}`}>
                    <img
                        className={`${styles.brandMark}`}
                        src="https://propertydek.com/static/img/logoW.svg"
                        alt="Propertydek"
                    />
                    <h1>Welcome back to<br />PropertyDek</h1>
                    <p>Choose how you'd like to sign in</p>
                </div>

                <div className={`${styles.options}`}>
                    <button type="button" className={`${styles.optCard}`} onClick={() => login("sms")}>
                        <span className={`${styles.optIcon}`}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="6" y="2" width="12" height="20" rx="2" />
                                <line x1="11" y1="18" x2="13" y2="18" />
                            </svg>
                        </span>
                        <span className={`${styles.optText}`}>
                            <div className={`${styles.optTitle}`}>Continue with phone</div>
                            <div className={`${styles.optSub}`}>We'll text you a verification code</div>
                        </span>
                        <svg className={`${styles.optChev}`} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="9 6 15 12 9 18" />
                        </svg>
                    </button>

                    <button type="button" className={`${styles.optCard}`} onClick={() => login("email")}>
                        <span className={`${styles.optIcon} ${styles.optIconEmail}`}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="2" y="4" width="20" height="16" rx="2" />
                                <polyline points="2 6 12 13 22 6" />
                            </svg>
                        </span>
                        <span className={`${styles.optText}`}>
                            <div className={`${styles.optTitle}`}>Continue with email</div>
                            <div className={`${styles.optSub}`}>We'll text a code to verify your email.</div>
                        </span>
                        <svg className={`${styles.optChev}`} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="9 6 15 12 9 18" />
                        </svg>
                    </button>
                </div>

            </div>

            {/* RIGHT: image */}
            <div className={`${styles.right}`}>
            </div>

        </div>

    </>)
}

export default LogIn;